import { QUOTE_GROUP_TYPES } from '../../redux/blocs/blocE/actions';

export const quoteReference = detail => {
  const groupLabel = QUOTE_GROUP_TYPES[detail?.quoteGroupName]?.label;
  if (!groupLabel) return null;
  const location =
    detail.quoteGroupState === 'project'
      ? 'projet'
      : detail.quoteGroupTab && `onglet ${detail.quoteGroupTab}`;
  return [groupLabel, location, detail.quoteNumber && `devis ${detail.quoteNumber}`]
    .filter(Boolean)
    .join(' · ');
};
